import type { RaceEvent } from "src/types/domain/RaceEvent"

/**
 * Whether the social panel should be mounted for the current game/round.
 *
 * EVERY game now stays mounted through `race_settled` / `race_cancelled`.
 *
 * It used to unmount there for marble games, and only crash was special-cased
 * to stay (v16/ASK 2). But settlement is exactly when the panel has the most
 * to say: the winners tally and "Total won" only exist AFTER the round
 * settles, so unmounting threw the payoff away and left a player who glanced
 * up a second late with nothing at all. It also meant a mid-round refresh on
 * those games could land in a gap with no feed.
 *
 * The `isCrashGame` argument is kept so existing call sites and tests compile
 * unchanged, but it no longer changes the answer.
 *
 * The game-id guard is what still unmounts the panel, and must stay: without
 * it, switching games would leave the previous game's bets on screen.
 */
export const showSocial = (
  gameId: string,
  betsGameId?: string,
  event?: RaceEvent,
  _isCrashGame = false
): boolean => {
  if (!event) return false
  if (!betsGameId) return false

  if (gameId !== betsGameId) return false

  return true
}
